import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_GET_LISTING_BY_ADDRESS_FIELDS,
} from 'api/actionTypes';

import {
  actionAddListingsToStateManager,
} from 'client/helpers/listingsStateManager';

export default async function getByAddressFields({ state, apiClient }, addressFields) {
  typeCheck('addressFields::NonEmptyObject', addressFields);

  let listing;

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_BY_ADDRESS_FIELDS,
    state: state,
    payload: addressFields,
    onSuccess(loadedListing) {
      if (loadedListing) {
        listing = loadedListing;
        state.set(['listing'], listing);

        actionAddListingsToStateManager({ state }, { listings: [listing] });
      }
    },
  });

  return listing;
}
